import { render, staticRenderFns } from "./ActionTransitions.vue?vue&type=template&id=246522f0"
import script from "./ActionTransitions.vue?vue&type=script&lang=js"
export * from "./ActionTransitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports